import { Link } from 'react-router-dom';
import { User } from './types/User';
import { startCase } from 'lodash';
import { useState } from 'react';
import { MdContentCopy } from 'react-icons/md';
import { toast } from 'react-hot-toast';
import UserDetailsDrawer from './drawers/UserDetailsDrawer';
import { useUserContext } from '~/context/UserProvider';

interface Props {}

const UserProfilePanel: React.FC<Props> = () => {
    const { user, userDispatch } = useUserContext();
    const [isOpen, setIsOpen] = useState(false);

    const getFormattedDepartments = (departments: { name: string }[]) => {
        if (departments && departments.length > 0)
            return departments.map((dept) => dept.name).join(', ');

        return '';
    };

    return (
        <>
            <div className='mb-[20px] flex flex-wrap justify-between'>
                <h2 className='text-[28px]/[32px] font-bold'>Profile</h2>
                <button
                    className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
                    onClick={() => setIsOpen(true)}
                >
                    Edit
                </button>
            </div>

            {/* <div className='text-[12px]/[16px] text-[#949599]'>Username</div>
            {user?.username} */}

            <div className='mt-[15px] text-[12px]/[16px] text-[#949599]'>
                Email
            </div>
            <div className='flex items-center gap-2'>
                <Link
                    className='break-words text-[#00AEB3]'
                    to={`mailto:${user?.person?.email}`}
                >
                    {user?.person?.email}
                </Link>
                {user?.person?.email && (
                    <button
                        type='button'
                        onClick={() => {
                            navigator.clipboard.writeText(user?.person?.email);
                            toast.success('Email copied to clipboard');
                        }}
                        className='rounded p-1 transition-colors'
                        style={{ color: '#00AEB3' }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#E6F7F8';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                        }}
                        title='Copy email'
                    >
                        <MdContentCopy size={16} />
                    </button>
                )}
            </div>

            {user?.person?.phone_set?.map((phone) => (
                <div key={phone.phone} className='mt-[15px]'>
                    <div className='text-[12px]/[16px] text-[#949599]'>
                        {phone?.type || 'Phone'}
                    </div>
                    <Link className='break-words text-[#00AEB3]' to={`tel:${phone.phone}`}>
                        {phone.phone}
                    </Link>
                </div>
            ))}

            <div className='mt-[15px] text-[12px]/[16px] text-[#949599]'>
                Roles
            </div>
            {user.roles.map((role) => (
                <div key={role} className='break-words'>
                    {startCase(role)}
                </div>
            ))}

            {(user.roles?.includes('administrator') ||
                user.roles?.includes('staff')) && (
                <>
                    <div className='mt-[15px] text-[12px]/[16px] text-[#949599]'>
                        Departments
                    </div>
                    {getFormattedDepartments(user?.departments)}
                </>
            )}
            <div className='mt-[15px] text-[12px]/[16px] text-[#949599]'>
                Date Created
            </div>
            {user.date_joined
                ? new Date(user.date_joined).toLocaleDateString()
                : ''}

            <div className='mt-[15px] text-[12px]/[16px] text-[#949599]'>
                Last Login
            </div>
            {user.last_login && new Date(user.last_login).getFullYear() > 1970
                ? new Date(user.last_login).toLocaleString()
                : ''}

            <UserDetailsDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    );
};

export default UserProfilePanel;
